export default __webpack_public_path__ + "static/acpr-ac84f6e86811630adf40fa8e666b6ab6.png";